import { Children, ReactNode } from 'react';

import { Skeleton, Stack } from '@cast/design-system';

type DashboardBlockSkeletonProps = {
  height?: number;
};

const DashboardBlockSkeleton = ({
  height = 36,
}: DashboardBlockSkeletonProps) => (
  <Skeleton
    variant="rounded"
    height={height}
    sx={{ flex: 1, minWidth: 0, width: '100%' }}
  />
);

export const ChartSummaryMetricSkeleton = () => <DashboardBlockSkeleton />;

type ChartSummaryMetricsRowSkeletonProps = {
  children: ReactNode;
  alwaysRow?: boolean;
};

export const ChartSummaryMetricsRowSkeleton = ({
  children,
  alwaysRow = false,
}: ChartSummaryMetricsRowSkeletonProps) => (
  <Stack
    direction={alwaysRow ? 'row' : { none: 'column', laptop: 'row' }}
    gap={16}
    sx={{ '& > *': { flex: 1, minWidth: 0 } }}
  >
    {Children.toArray(children)}
  </Stack>
);
